module.exports = __webpack_public_path__ + "img/share5.a2adcabc.png";